import { useAppForm as useAppFormBase } from '@worldcoo/ui/components/form';
import { useZodI18n } from './zod-i18n';
import { getRuntimeRecaptchaSiteKey } from './shared';
import { useEffect } from 'react';

function useRecaptcha() {
	useEffect(() => {
		const siteKey = getRuntimeRecaptchaSiteKey();
		if (!siteKey) return;

		const scriptId = 'recaptcha-script';
		if (document.getElementById(scriptId)) return;

		const script = document.createElement('script');
		script.id = scriptId;
		script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
		script.defer = true;
		document.head.appendChild(script);
	}, []);
}

export const useAppForm: typeof useAppFormBase = (...args) => {
	useZodI18n();
	useRecaptcha();
	return useAppFormBase(...args);
};
